import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-gray-800 bg-gray-900 dark:border-gray-800 dark:bg-gray-900">

      {/* Main Footer */}
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">

          {/* Brand Column */}
          <div className="lg:col-span-5">

            <a href="/" className="flex items-center gap-3 max-w-[90px]">
              <img src="assets/img/light-logo-opdcover.png" alt="brand logo" className="w-[110px]" />
            </a>

            <p className="mt-4 max-w-xs text-gray-400 dark:text-gray-400 footer-text">
              <div>
                At Saayaa, we believe healthcare shouldn’t start only when you fall sick — it should support you every single day.
              </div>
            </p>
            {/* Social Links */}
            {/* <div className="mt-6 flex gap-4">
              
              <a
                href="https://twitter.com/skillforge"
                className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                aria-label="Twitter"
              >
                
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                </svg>
              </a>
              <a
                href="https://linkedin.com/company/skillforge"
                className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                aria-label="LinkedIn"
              >
                
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                </svg>
              </a>
              <a
                href="https://youtube.com/@skillforge"
                className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                aria-label="YouTube"
              >
                
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                </svg>
              </a>
              <a
                href="https://instagram.com/skillforge"
                className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                aria-label="Instagram"
              >
                
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"></path>
                </svg>
              </a>
            </div> */}
          </div>
          {/* Quick Linkss */}
          <div className="lg:col-span-2">
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-white dark:text-white">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-3 footer-text">
              <li>

                <a
                  href="/"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Home
                </a>
              </li>
              <li>

                <a
                  href="/plans"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Plans
                </a>
              </li>
              <li>

                <a
                  href="/contact"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          {/* Policies */}
          <div className="lg:col-span-2">
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-white dark:text-white">
              Terms & Policies
            </h3>
            <ul className="mt-4 space-y-3 footer-text">
              <li>

                <a
                  href="/term-of-use"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Term and Conditions
                </a>
              </li>
              <li>

                <a
                  href="/privacy-policy"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Privacy Policy
                </a>
              </li>
              <li>

                <a
                  href="/Shipping-delivery-policy"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  Shipping Policy
                </a>
              </li>
              <li>

                <a
                  href="/cancellation-policy"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  cancellation Policy
                </a>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div className="lg:col-span-3">
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-white dark:text-white">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 footer-text">
              <li>

                <a
                  href="tel:+918010961096"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  <i class="fa-solid fa-phone mr-1"></i> +91 80 1096 1096
                </a>
              </li>
              <li>

                <a
                  href="mailto:info@opdcover.com"
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  <i class="fa-solid fa-envelope mr-1"></i> info@opdcover.com
                </a>
              </li>
              <li>

                <div
                  className="text-gray-400 transition-colors hover:text-primary-400 dark:text-gray-400 dark:hover:text-primary-400"
                >
                  <i class="fa-solid fa-location-arrow mr-1"></i> Plot-455, 2nd floor, Najafgarh road, Metro pillar no. 796, New Delhi, 110078
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-gray-800 dark:border-gray-800">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-sm text-gray-400 dark:text-gray-400">
              © 2026 Saayaa. All rights reserved.
            </p>
            <div className="text-sm text-gray-400 hover:text-gray-300 dark:text-gray-400 dark:hover:text-gray-300 max-md:text-center">
              Powered By Saayaa Health - Wellness Services Private Limited

            </div>
          </div>
        </div>
      </div>

      <div className="footer-fixed fixed bottom-[10px] right-[10px] z-[999999]">
        <a href="https://wa.me/919911556272" target="new">
          <i class="fa-brands fa-square-whatsapp text-[#4FE55F] text-[60px]"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
